import { axiosInstance } from '../../api';
const BASE_PATH = '/schedule_interview';

//Get Pending Interviews API Call
export let getPendingInterviews = async (pipeline_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pending_interviews', {
            is_scheduled: false,
            pipeline_id: pipeline_id
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get Scheduled Interviews API Call
export let getSheduledInterviews = async (pipeline_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pending_interviews', {
            is_scheduled: true,
            pipeline_id: pipeline_id
        })
        return value;
    } catch (error) {
        return error
    }
}

//Shedule a Interview API Call
export let SheduleInterview = async (sessionID, dateAndTime, timeZone, interviewersArray, interviewType, interviewLocation, guidelineDescription, onlineInterviewUrl) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/schedule_interview', {
            session_id: sessionID,
            date_time: dateAndTime,
            time_zone: timeZone,
            interviewers: interviewersArray,
            interview_type: interviewType,
            interview_location_address: interviewLocation,
            interview_guidelines_to_candidate: guidelineDescription,
            interview_online_url : onlineInterviewUrl,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Shedule a Interview API Call
export let ReSheduleInterview = async (sessionID, dateAndTime, timeZone, interviewersArray, interviewType, interviewLocation, guidelineDescription, onlineInterviewUrl) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reschedule_interview', {
            session_id: sessionID,
            date_time: dateAndTime,
            time_zone: timeZone,
            interviewers: interviewersArray,
            interview_type: interviewType,
            interview_location_address: interviewLocation,
            interview_guidelines_to_candidate: guidelineDescription,
            interview_online_url : onlineInterviewUrl,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Shedule a Interview API Call
export let cancelSheduledInterview = async (sessionID, interviewCancelEmailConfirmation) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/cancel_scheduled_interview', {
            session_id: sessionID,
            need_to_send_email_notification: interviewCancelEmailConfirmation     
        })
        return value;
    } catch (error) {
        return error
    }
}

//evaluate based on current mark API Call
export let evaluateBasedOnResult = async (sessionID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/evaluate_candidate_with_available_feedback', {
            session_id: sessionID
        })
        return value;
    } catch (error) {
        return error
    }
}

//Cancel and reject interview
export let cancelAndRejectInterview = async (sessionID, reason, interviewCancelEmailConfirmation) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/cancel_and_reject_scheduled_interview', {
            session_id: sessionID,
            manually_failed_reason: reason,
            need_to_send_email_notification: interviewCancelEmailConfirmation
        })
        return value;
    } catch (error) {
        return error
    }

}

//get Hiring Piepelines Of Interviews
export let getHiringPiepelinesOfPendingInterviews = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_hiring_pipelines_of_pending_interviews')
        return value;
    } catch (error) {
        return error
    }
}


//get Hiring Piepelines Of Interviews
export let getHiringPiepelinesOfSheduledInterviews = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_hiring_pipelines_of_sheduled_interviews')
        return value;
    } catch (error) {
        return error
    }
}

//Get Scheduled Interviews API Call
export let getSheduledInterviewsOfDay = async (date) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_sheduled_interviews_of_day', {
            date: date
        })
        return value;
    } catch (error) {
        return error
    }
}